window.keepScrollDisabled = false;

import './autoload/bootstrap';

import './global/accessibility';
import './global/lenis';
import './global/common';
import './global/nav';
import './global/swiper';
import './global/search';
import './global/gmaps';
import './global/wpsl-hover-marker';
import './global/admin';
import './global/scroll-indicator';
import './global/scrollable';
import './global/inview-animations';
import './global/search';
import './global/wpsl-search';

import features from '/features.json';

if (features.woocommerce) {
  import('./features/woocommerce/checkout');
  import('./features/woocommerce/product');
  import('./features/woocommerce/product-docs-lightbox');
  import('./features/woocommerce/sticky-product');
  import('./features/woocommerce/readmore');
  import('./features/woocommerce/updatecartqty');

  if (features.woocommerce_addtocartmodal) {
    import('./features/woocommerce/addtocart');
  }

  if (features.woocommerce_offer) {
    import('./features/woocommerce/addtooffer');
  }
}

if (features.search) {
  import('./features/search');
}

if (features.tab_notification) {
  import('./features/tab-notification');
}

import.meta.glob(['../images/**', '../fonts/**']);
